import { injectGlobal } from 'styled-components'

import colors from './colors'

injectGlobal`
  *:before,
  *:after,
  * {
    box-sizing: border-box;
    font-family: -apple-system, BlinkMacSystemFont, sans-serif;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
  }

  html,
  body {
    margin: 0;
    padding: 0;
    line-height: 1.4;
    color: ${colors.primaryText};
    line-height: 1.5;
  }

  html,
  body,
  #root {
    min-height: 100vh;
  }

  body {
    max-width: 800px;
    margin: 0 auto;
    padding: 0 1rem;
  }

  p {
    margin: 0 0 1rem;
  }

  hr {
    border: none;
    height: 2px;
    background: #eee;
    margin: 1rem 0;
  }

  h1 {
    font-size: 1.3rem;
    margin: 2rem 0 1rem;
    font-weight: 700;
  }
  h2 {
    font-size: 1.2rem;
    font-weight: 500;
  }
  h2.small-text {
    text-transform: uppercase;
    letter-spacing: 0.025rem;
    color: ${colors.tertiaryText};
    font-size: .9rem;
    font-weight: 600;
    margin: 2rem 0 1rem;
  }

  ::placeholder {
    color: ${colors.tertiaryText};
  }
`



// WEBPACK FOOTER //
// ./src/styles/global.js